export default "__VITE_ASSET__CIt$XSMP__"